import React from 'react'
import { submitReportProgress } from '@/enums/submitReportProgress'
import context from '@/context'
import { BackgroundJobCard } from '@/report-app/pages/reporting/submissions/submit/backgroundJobCard'

function RecalculatingSubmissionCard ({ submitProgress, reportInstanceGroupId, backgroundJobMetadata, onJobStarted }) {
  return <BackgroundJobCard dataCy='recalculatingSubmissionCard'
    backgroundJobMetadata={backgroundJobMetadata}
    onJobStarted={onJobStarted}
    reportInstanceGroupId={reportInstanceGroupId}
    submitProgress={submitProgress}
    headerText='Reporting.RecalculatingCells'
    beforeStartText='Reporting.RecalculateCells'
    bgJobSubmitProgress={submitReportProgress.enum.Recalculated}
    startCardSubmitProgress={submitReportProgress.enum.Started}
    bgJobEndpoint={context.api.reportSubmissionGroupService.recalculateSubmission} />
}

export { RecalculatingSubmissionCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/recalculatingSubmissionCard.js